import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isRoomRemoteLoading: false,
  isChannelDataLoading: false,
  isMediaListLoading: false,
  currentTv: null,
  roomRemoteDetails: null,
  mediaList: [],
  selectedDeviceIndex: 0,

  channelData: null,
  languageGrouping: null,
  categoryGrouping: null,
  currentChannel: null,
};

const tvRemoteSlice = createSlice({
  name: 'tvRemote',
  initialState,
  reducers: {
    resetTvRemote: () => initialState,
    setIsRoomRemoteLoading: (state, action) => {
      state.isRoomRemoteLoading = action.payload;
    },
    setIsChannelDataLoading: (state, action) => {
      state.isChannelDataLoading = action.payload;
    },
    setIsMediaListLoading: (state, action) => {
      state.isMediaListLoading = action.payload;
    },
    setCurrentTv: (state, action) => {
      state.currentTv = action?.payload;
    },
    setSelectedDeviceIndex: (state, action) => {
      state.selectedDeviceIndex = action?.payload;
    },
    setRoomRemoteDetails: (state, action) => {
        state.roomRemoteDetails = action.payload;
        state.isRoomRemoteLoading = false;

        if(action.payload?.length > 1){
          state.currentTv = null
        } else {
          state.currentTv = action.payload?.[0];
          state.selectedDeviceIndex = 0;
        }
    },
    setMediaList: (state, action) => {
      state.mediaList = action.payload;
      state.isMediaListLoading = false
    },
    setChannelList: (state, action) => {
        state.channelData = action.payload?.channelData,
        state.languageGrouping = action.payload?.languageGrouping,
        state.categoryGrouping = action.payload?.categoryGrouping,
        state.currentChannel = action.payload?.channelData?.[0]
    }
  },
});

export const { resetTvRemote, setIsRoomRemoteLoading, setIsChannelDataLoading, setIsMediaListLoading, setCurrentTv, setSelectedDeviceIndex, setRoomRemoteDetails, setMediaList, setChannelList } = tvRemoteSlice.actions;

export default tvRemoteSlice.reducer;
  